import { Component, OnInit ,EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { GetdataService } from './getdata.service';
import { Router} from '@angular/router';


@Component({
  selector: 'app-interviewrating',
  templateUrl: './interviewrating.component.html',
  styleUrls: ['./interviewrating.component.css']
})
export class InterviewratingComponent implements OnInit {


 public id:number;
   public userdata: any ={

                    c_rating:'',
                     p_rating:'',      
                     a_rating:'',
                     t_rating:'',
                    c_cmt:'',
                    p_cmt:'',
                    a_cmt:'',
                    t_cmt:'',
                    comment:'',
                    final_cmt:'',
                    remark:''

          
        };
  getdata ={

                    c_rating:'',
                     p_rating:'',      
                     a_rating:'',
                     t_rating:'',
                    c_cmt:'',
                    p_cmt:'',
                    a_cmt:'',
                    t_cmt:'',
                    comment:'',
                    final_cmt:'',
                    remark:''

          
        };
        submitted=false;
  
datalist: Array<any> = [];
 resultlist: Array<any> = [];
  
  constructor(private service: GetdataService,private router:Router){

  }

  ngOnInit(){

     this.id = this.service.selectId;
   console.log("In interview rating on it" +this.id );

       this.service.getUserData().subscribe(
       (data: any) =>{
         console.log(data);
          this.resultlist = data
        console.log('In rating Component resultlist here '+ this.resultlist);
       });
  
  }


       

        savedata(form: NgForm)
       {
          this.submitted=true;

          this.userdata.c_rating=form.value.c_rating;
         this.userdata.p_rating=form.value.p_rating;
         this.userdata.a_rating=form.value.a_rating;
         this.userdata.t_rating=form.value.t_rating;
         this.userdata.c_cmt=form.value.c_cmt;
         this.userdata.p_cmt=form.value.P_cmt;
         this.userdata.a_cmt=form.value.a_cmt;
         this.userdata.t_cmt=form.value.t_cmt;
         this.userdata.comment=form.value.comment  ;
         this.userdata.final_cmt=form.value.final_cmt;
         this.userdata.remark=form.value.remark;

      

       console.log("feedback data"+this.userdata);

         this.datalist= this.userdata;
  console.log("feedback data in array "+this.datalist);

            this.service.setValue('c_rating', this.userdata.c_rating);
            this.service.setValue('p_rating', this.userdata.p_rating);
             this.service.setValue('a_rating', this.userdata.a_rating);
            this.service.setValue('t_rating', this.userdata.t_rating);
            this.service.setValue('c_cmt', this.userdata.c_cmt);
            this.service.setValue('p_cmt',this.userdata.p_cmt);
            this.service.setValue('a_cmt', this.userdata.a_cmt);
            this.service.setValue('t_cmt', this.userdata.t_cmt);
            this.service.setValue('comment', this.userdata.comment);
            this.service.setValue('final_cmt', this.userdata.final_cmt);
            this.service.setValue('remark', this.userdata.remark);
           
          
          


       this.service.sendUserData()
    .subscribe(response=> 

         {
               console.log(response);
             
             

       });
       this.service.deletedata_byid().subscribe(response=> 

       {
 
               console.log(response);
             
             

      });

       }
}



// WEBPACK FOOTER //
// C:/Users/USer/Interviewfeedback/src/app/interviewrating/interviewrating.component.ts